<template>
	<!--左侧菜单-开始-->
	<div class="left_pannel_box">
		<ul>
			<li :class="fileName === 'index' ?'selected':''">
				<div class="item_box">
					<a href="index">
					<div class="icon home"></div>
					<div class="menu_txt">
						<h3>我的帳戶</h3>
						<p>一站式個人帳號與資產訂單管理</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'orders' ?'selected':''">
				<div class="item_box">
					<a href="orders">
					<div class="icon order"></div>
					<div class="menu_txt">
						<h3>訂單中心</h3>
						<p>追蹤訂單，隨時獲知最新動態</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'collections' ?'selected':''">
				<div class="item_box">
					<a href="collections">
					<div class="icon favorite"></div>
					<div class="menu_txt">
						<h3>收藏夾</h3>
						<p>及時了解關注內容的價格變動</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'profile' ?'selected':''">
				<div class="item_box">
					<a href="profile">
					<div class="icon contact"></div>
					<div class="menu_txt">
						<h3>個人資訊</h3>
						<p>設置通訊資訊，隨時保持聯絡</p>
					</div>
					</a>
				</div>
			</li>
			<li :class="fileName === 'reset_password' ?'selected':''">
				<div class="item_box">
					<a href="reset_password">
					<div class="icon password"></div>
					<div class="menu_txt">
						<h3>重設密碼</h3>
						<p>請妥善保管好您的密碼</p>
					</div>
					</a>
				</div>
			</li>
		</ul>
		<div class="logout">
			<a href="javascript:void(0)" @click="userLogout()">退出登錄</a>
		</div>
	</div>
	<!--左侧菜单-结束-->
</template>

<script>
	import {
		userLogout,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'CNUserLeftPannel',
		props: ['fileName','Token'],
		mixins: [mixin],
		data() {
			return {				
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
			}
		},
		methods: {
			// 退出登录
			async userLogout()
			{
				let params={
					Token: this.Token,
					Terminal: this.terminal,
				}
				
				const { data: res } = await userLogout(params)
				if (res.errcode === 0) {
					this.$storeage.remove('token')
					this.$storeage.remove('expire')
					this.token = null
					this.loginStatus = false
					
					this.$router.push({
						path: '/tw/user/login'
					})
				} else {
					this.$message.error(res.errmsg);
				}
			}
		},
		created() {
		},
		beforeDestroy() {

		}
	}
</script>

<style lang="less" scoped>

</style>